import { render, staticRenderFns } from "./kTest.vue?vue&type=template&id=184ca7a9&"
import script from "./kTest.vue?vue&type=script&lang=js&"
export * from "./kTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports